<div class="page">
    <div class="card">
        <div class="no-plan" *ngIf="!plan && !(loading && !loadingTask)">
            <p>{{ 'admin.tools.details.maintenancePlanPage.notPartOfPlan' | translate }}</p>
        </div>

        <div class="loader" *ngIf="loading && !loadingTask">
            <app-loading-spinner></app-loading-spinner>
        </div>

        <app-maintenance-plan-overview *ngIf="plan && !(loading && !loadingTask)"
                                       [maintenancePlan]="plan"
                                       [isLoadingTools]="isLoadingTools"
                                       [detailsView]="true"
                                       [hasNavigation]="!!tool && canViewMaintenancePlanDetails()"
                                       [showControls]="!tool && !isReadOnly"
                                       [showVersion]="!tool"
                                       [hasNavigationForActivities]="canViewMaintenancePlanDetails()"
                                       (edit)="onEdit($event)"
                                       (duplicate)="onDuplicate($event)"
                                       (delete)="onDelete($event)"
                                       (navigate)="goToPlan($event)"
                                       (taskClicked)="onTaskClicked($event)">
        </app-maintenance-plan-overview>

    </div>
</div>

<app-maintenance-plan-modal [isEdit]="!isDuplicate"
                            [isDuplicate]="isDuplicate"
                            (submit)="handleEditPlan($event)">
</app-maintenance-plan-modal>

<app-confirmation-modal #versionConfirmationModal
                        class="confirmation-modal"
                        [confirmOnlyMode]="true"
                        [title]="'admin.toolMaintenancePlans.plans.confirmModal.title' | translate"
                        [question]="'admin.toolMaintenancePlans.plans.confirmModal.question' | translate"
                        [isCustomContent]="true"
                        (confirmEvent)="onEditPlan()">
    <app-input-switch modal-custom-content
                      [(ngModel)]="incrementVersion"
                      name="incrementVersion"
                      onLabel="{{'generic.yes' | translate}}"
                      offLabel="{{'generic.no' | translate}}">
    </app-input-switch>
</app-confirmation-modal>

<app-confirmation-modal #deleteConfirmationModal
                        class="confirmation-modal"
                        [confirmOnlyMode]="true"
                        [question]="'admin.toolMaintenancePlans.plans.deleteModal.question' | translate"
                        [title]="'admin.toolMaintenancePlans.plans.deleteModal.title' | translate"
                        (confirmEvent)="onDeletePlan()">
</app-confirmation-modal>

<app-modal #taskDetails>
    <h1 modal-header>{{ 'admin.toolMaintenancePlans.plans.taskDetails' | translate }}</h1>
    <app-task-form #taskForm
                   modal-body
                   [readonly]="true"
                   [roles]="taskRole ? [taskRole] : null"
                   [isEdit]="true">
    </app-task-form>
    <app-button type="simple" modal-footer (click)="closeTaskModal()">{{ 'generic.buttons.close' | translate }}
    </app-button>
</app-modal>
